import React from 'react';
import BulkDiscountsForm from '@dashboard/components/BulkDiscountsForm';
import CanUseFeature from '@dashboard/components/CanUseFeature';
import Features from '@dashboard/enums/features';
import usePage from '@dashboard/hooks/usePage';

const EventDiscountsForm = () => {
  const { page, updatePage } = usePage();

  const ticketTypes = page.ticketGroups.flatMap(tg => tg.ticketTypes);
  const currency = page.eventDetails?.currency;
  const savedDiscounts = page?.eventDetails?.discounts || [];

  const config = {
    itemsFieldName: 'ticketTypes',
    defaultQuantityCondition: 'totalQuantity',
    quantityConditionLabel: 'Discount applies to',
    quantityConditionTooltip:
      'Apply this discount based on total selected quantity or quantity per ticket.',
    allItemsLabel: 'All tickets',
    allItemsValue: 'totalQuantity',
    perItemLabel: 'Per ticket',
    perItemValue: 'ticketTypeQuantity',
    itemsLabel: 'Ticket types',
    itemsPlaceholder: 'Select ticket types',
    itemsValidationMessage: 'Select at least one ticket type',
    itemOptions: ticketTypes.map(ticketType => ({
      name: ticketType.name,
      value: ticketType._id,
    })),
  };

  const handleSubmit = async discounts => {
    const body = {
      eventDetails: {
        ...page.eventDetails,
        discounts,
      },
    };

    const { data, error } = await updatePage.mutateAsync(body);

    if (data) {
      return { data: data.eventDetails.discounts };
    }

    return { error };
  };

  return (
    <CanUseFeature feature={Features.BULK_DISCOUNTS}>
      <BulkDiscountsForm
        config={config}
        savedDiscounts={savedDiscounts}
        currency={currency}
        onSubmit={handleSubmit}
      />
    </CanUseFeature>
  );
};

export default EventDiscountsForm;
